import MyInterestsCode from './MyInterests.jsx';

const About = () => {
  return (
    <div className='about'>
      {/* Add content for the About section */}
      <h2>About Me</h2>
      <p>Hi, I'm Sahib Sidhu, a fervent Full Stack Developer and Web Designer who has an enthusiasm for creating aesthetically pleasing and flawless web applications.</p>

      <p>My quest to learn new things and adjust to the always-changing tech landscape has driven my progress in the field of web development. I enjoy the difficulties of creating reliable, scalable apps, from front-end magic to back-end logic.</p>

      <MyInterestsCode/>
      
      <div className="divider"></div>
    </div >
  );
};

export default About;